// extracted by mini-css-extract-plugin
module.exports = {"label":"sideMenuHeader_label_2qXL9jf"};